import { UsersIcon } from 'lucide-react';
import { DetailList } from '../DetailList/DetailList';
import { DetailStack } from '../DetailStack/DetailStack';
import { getWidgetStores, InfoCard } from '@/entities/widget';
import { SectionTitle } from '../SectionTitle/SectionTitle';
import { DetailSection } from '../DetailSection/DetailSection';
import type { CustomerUnderstandingSectionProps } from './CustomerUnderstandingSection.types';
import { useTranslation } from 'react-i18next';

export function CustomerUnderstandingSection(props: CustomerUnderstandingSectionProps) {
  const { t } = useTranslation('contentTest');

  return (
    <div data-testid="social-brief-customer-understanding-section">
      <SectionTitle
        title={t('socialBriefWidget.customerUnderstandingSection.customerUnderstanding')}
        icon={<UsersIcon className="size-5" />}
        tooltip={t('socialBriefWidget.customerUnderstandingSection.understandingOfTheCustomerTo')}
      />
      <DetailSection>
        <TargetAudience {...props} />
        <CulturalContext {...props} />
      </DetailSection>
    </div>
  );
}

function TargetAudience({ item }: CustomerUnderstandingSectionProps) {
  const { t } = useTranslation('contentTest');

  return (
    <DetailStack>
      <span className="text-body-lg font-medium text-foreground">
        {t('socialBriefWidget.customerUnderstandingSection.targetAudienceDemandSpace')}
      </span>

      <InfoCard style="w-full">
        <DetailStack>
          <span className="text-body-lg font-medium text-muted-foreground">
            {t('socialBriefWidget.customerUnderstandingSection.segments')}
          </span>

          <DetailList>
            {item.customerUnderstanding.targetAudienceOrDemandSpace.map((audience, index) => (
              <li key={index} className="text-body-lg text-foreground">
                {audience}
              </li>
            ))}
          </DetailList>
        </DetailStack>
      </InfoCard>
    </DetailStack>
  );
}

function CulturalContext({ item }: CustomerUnderstandingSectionProps) {
  const { t } = useTranslation('contentTest');

  // ChatMarkdownRenderer via the entities/widget binding seam.
  const { ChatMarkdownRenderer } = getWidgetStores().chatStore;
  return (
    <DetailStack>
      <span className="text-body-lg font-medium text-foreground">
        {t('socialBriefWidget.customerUnderstandingSection.culturalContext')}
      </span>

      <InfoCard style="w-full">
        <DetailStack>
          <span className="text-body-lg font-medium text-muted-foreground">
            {t('socialBriefWidget.customerUnderstandingSection.popCultureEventAnchors')}
          </span>

          <DetailList>
            {item.customerUnderstanding.culturalContext.map((context, index) => (
              <li key={index} className="text-body-lg text-foreground">
                <ChatMarkdownRenderer content={context} disableAnimation inline />
              </li>
            ))}
          </DetailList>
        </DetailStack>
      </InfoCard>
    </DetailStack>
  );
}
